import React from 'react'

import { Message } from 'rsuite'

export interface CommonErrorDisplayProps {
  title?: string
  error?: Error
}

const CommonErrorDisplay: React.FC<CommonErrorDisplayProps> = ({
  error,
  title = 'Ошибка выполнения запроса',
  children
}) => {
  if (error) {
    return (
      <Message
        className="CommonErrorDisplay"
        type="error"
        header={title}
        showIcon
      >
        <p>
          <strong>{error.message}</strong>
        </p>

        {children}
      </Message>
    )
  }

  return null
}

export default CommonErrorDisplay
